(function () {
    function initMegaMenuContentHydration() {
        if (window.__megaMenuContentHydrateInit) return;
        window.__megaMenuContentHydrateInit = true;

        function hydrateSingleImage(el) {
            if (el.querySelector('img')) return;
            var encoded = el.getAttribute('data-mega-src-secure');
            if (!encoded) return;

            var decodedSrc = atob(encoded);
            var img = document.createElement('img');
            img.className = 'mega-menu-content__image';
            img.alt = el.getAttribute('data-mega-alt') || '';
            img.src = decodedSrc;

            var srcset = el.getAttribute('data-mega-srcset');
            if (srcset) img.srcset = srcset;

            var sizes = el.getAttribute('data-mega-sizes');
            if (sizes) img.sizes = sizes;

            el.appendChild(img);
        }

        function hydrateMegaMenuImages(navItemRoot) {
            navItemRoot.querySelectorAll('[data-mega-src-secure]').forEach(hydrateSingleImage);
        }

        function removeMegaMenuImages(navItemRoot) {
            navItemRoot.querySelectorAll('[data-mega-src-secure] img').forEach(function (img) {
                img.remove();
            });
        }

        function isNavDropdownOpen(navItemLi, innerNavItem) {
            if (navItemLi.classList.contains('nav-item--expanded')) return true;
            return innerNavItem && innerNavItem.getAttribute('expanded') === 'true';
        }

        document.querySelectorAll('[data-hover-intent-item].nav-item').forEach(function (navItemLi) {
            if (!navItemLi.querySelector('[data-mega-src-secure]')) return;

            var innerNavItem = navItemLi.querySelector('nav-item');

            function syncMegaMenuImages() {
                if (isNavDropdownOpen(navItemLi, innerNavItem)) {
                    hydrateMegaMenuImages(navItemLi);
                } else {
                    removeMegaMenuImages(navItemLi);
                }
            }

            var mo = new MutationObserver(syncMegaMenuImages);
            mo.observe(navItemLi, { attributes: true, attributeFilter: ['class'] });
            if (innerNavItem) {
                mo.observe(innerNavItem, { attributes: true, attributeFilter: ['expanded'] });
            }

            syncMegaMenuImages();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMegaMenuContentHydration);
    } else {
        initMegaMenuContentHydration();
    }
})();